<template lang="pug">
  v-avatar(
    v-bind="$attrs"
    v-on="$listeners"
    :color="color")
    v-img(
      :src="image.src"
      :lazy-src="image.srcLazy")
</template>

<script>
import { defaultSrc } from '..'
import { computed, reactive, toRefs, onMounted } from '@vue/composition-api'

export default {
  inheritAttrs: false,

  props: {
    colorOverride: String
  },

  setup (props, { attrs }) {
    const state = reactive({
      color: computed(
        () => props.colorOverride ?? (attrs.src?.[0] === `#`
          ? attrs.src
          : null)
      ),
      isPlaceholder: computed(
        () => !!state.color
      ),
      image: computed(
        () => state.isPlaceholder
          ? ({
            src: defaultSrc.value,
            srcLazy: defaultSrc.value
          }) : ({
            src: attrs.src,
            srcLazy: attrs.srcLazy
          })
      )
    })

    return {
      ...toRefs(state)
    }
  }
}
</script>
